import { Control } from '@Common/Controls/Controls';
import { enumerable } from '@Common/Core/CoreDecorator';

export enum StatusType {
    success,
    defeat,
    warning,
    inProcess
}

export class StatusControlParams {
    public initialStatus?: boolean = false;
    public className?: string = null;
    public size?: number = 24;
}

export class StatusControl implements Control {
    private readonly root: JQuery;
    private statusType: StatusType = StatusType.success;

    constructor(params?: StatusControlParams) {
        this.root = $('<div />', {
            class: 'status-control'
        });

        params = _.assign(new StatusControlParams(), params);
        params.className && this.root.addClass(params.className);
        this.adjust(params.size);
        this.setStatus(params.initialStatus);
    }

    private setClass(value: StatusType): void {
        const enumValues = _.keys(StatusType).map(_.toNumber).filter(_.negate(isNaN));

        for (const enumValue of enumValues) {
            const name = StatusType[enumValue];
            this.root.toggleClass(`${name}-state`, value === enumValue);
        }
    }

    public setStatus(available: boolean): void {
        this.status = available ? StatusType.success : StatusType.defeat;
    }

    @enumerable
    public get status(): StatusType {
        return this.statusType;
    }

    public set status(value: StatusType) {
        this.statusType = value;
        this.setClass(value);
    }

    public adjust(size?: number): void {
        this.root.outerWidth(size).outerHeight(size);
    }

    public getControl(): JQuery {
        return this.root;
    }

    public setState(enabled: boolean): void {
        $.noop();
    }
}
